#import "../workBlock/workBlockInfo.gql"
#import "./downtimeBlockInfo.gql"

mutation ScheduleDowntimeBlock(
  $id: ID!
  $reason: String!
  $reasonCode: String
  $startsAt: ISO8601DateTime!
  $endsAt: ISO8601DateTime!
  $lineId: ID!
  $lockedOnSchedule: Boolean!
) {
  scheduleDowntimeBlock(
    id: $id
    reason: $reason
    reasonCode: $reasonCode
    startsAt: $startsAt
    endsAt: $endsAt
    lineId: $lineId
    lockedOnSchedule: $lockedOnSchedule
  ) {
    downtimeBlock {
      ...downtimeBlockInfo
    }
  }
}

mutation UnscheduleDowntimeBlock($id: ID!) {
  unscheduleDowntimeBlock(id: $id) {
    downtimeBlock {
      id
    }
  }
}

subscription OnDowntimeBlockCreated {
  downtimeBlockCreated {
    downtimeBlock {
      ...downtimeBlockInfo
    }
  }
}

subscription OnDowntimeBlockDeleted {
  downtimeBlockDeleted {
    downtimeBlock {
      id
    }
  }
}

subscription OnDowntimeBlockUpdated {
  downtimeBlockUpdated {
    downtimeBlock {
      ...downtimeBlockInfo
    }
  }
}

subscription OnDowntimeBlocksUpdated {
  downtimeBlocksUpdated {
    downtimeBlocks {
      ...downtimeBlockInfo
    }
  }
}
